export default "__VITE_ASSET__CAJva96R__"